import { Box, Stack, Typography } from "@mui/material";
import { Container } from "@mui/system";
import React from "react";
import { styled } from "@mui/system";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from "@mui/material/MenuItem";


const Header = () => {
    const [open, setOpen] = React.useState(false);
  
    function handleOpen() {
        setOpen(!open);
    }
  
    function handleClose() {
        setOpen(false);
    }
  const Tab = styled(Button)({
    color: "#ffffff",
    fontSize: "18px",
    // fontFamily: "Gilroy",
  });
  return (
    <Container>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "50px 0px",
         
        }}
      >
        <Box>
          <Typography
            sx={{
              //   fontFamily: "sans serif",
              fontSize: "45px",
              fontWeight: "400",
              lineHeight: "36px",
              letterSpacing: "0em",
              textAlign: "left",
              color: "#fff",
              display:"flex",
              justifyContent:{xs:"flex-end"}
            }}
          >
            B.CTech
          </Typography>
        </Box>
        <Box sx={{display:{xs:"none",md:"none",lg:"block"}}}>
          <Stack spacing={5} direction="row">
            <Tab sx={{ color: "#14AD5C",borderBottom:"3px solid #14AD5C" }}>About Us</Tab>
            <Tab>Services</Tab>
            <Tab>How it works</Tab>
            <Tab>Community</Tab>
            <Button sx={{ color: "#fff", border: "2px solid #14AD5C" }}>
              Join for Free
            </Button>
          </Stack>
        </Box>
        <Box sx={{display:{xs:"block",lg:"none"}}}>
          <Button onClick={handleOpen} sx={{color:"black"}}>
           <MenuIcon sx={{color:"#fff"}}/>
            </Button>
            <Drawer anchor={"left"} open={open} 
                onClose={handleClose} >
                <MenuItem>About Us</MenuItem>
                <MenuItem>Services</MenuItem>
                <MenuItem>HOW IT WORKS</MenuItem>
                <MenuItem>COMMUNITY</MenuItem>
            </Drawer>
          </Box>
      </Box>
     
    </Container>
  );
};

export default Header;
